import { useState, useEffect } from "react";
import ApiRequest from "../../../helper/ApiRequest";
import { ApiEndpoints } from "../../../helper/ApiEndpoints";
import CustomSelect from "../../../component/CustomSelect";
import CustomImageUpload from "../../../component/CustomImageUpload";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import Icons from "../../../myIcon/Icons";
import { BaseUrl } from "../../../helper/BaseUrl";

const featureEditEndpoint = ApiEndpoints.featureCategory.featureEdit;
const featureUpdateEndPoint = ApiEndpoints.featureCategory.featureUpdate;

export default function EditFeatureCategory({ show, onHide, catId }) {
  const feature_category_id = catId;
  const [data, setData] = useState({ title: "", thumbnail: null, icon: null, brief: "", category_slug: "", });
  const StatusData = [{ _id: "1", title: "Disable" }, { _id: "0", title: "Enable" }];
  const [previews, setPreviews] = useState({
    thumbnail: null,
    icon: null,
  });

  useEffect(() => {
    const dataFetch = async () => {
      try {
        if (feature_category_id) {
          const response = await ApiRequest("GET", `${featureEditEndpoint}${feature_category_id}`);
          const result = response.feature_category;
          setData(result);
          setPreviews({
            thumbnail: result.thumbnail ? `${BaseUrl}/${result.thumbnail}` : null,
            icon: result.icon ? `${BaseUrl}/${result.icon}` : null,
          });
        }
      } catch (error) {
        console.log(error);
      }
    };

    dataFetch();

  }, [feature_category_id]);


  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      const file = files[0];
      setPreviews((prev) => ({
        ...prev,
        [name]: URL.createObjectURL(file),
      }));
      setData((prev) => ({
        ...prev,
        [name]: file,
      }));
    } else {
      setData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!data.title || !data.category_slug) {
      toast.error("Required fields missing.");
      return;
    }

    const formData = new FormData();
    formData.append("title", data.title);
    formData.append("brief", data.brief);
    formData.append("category_slug", data.category_slug);
    if (data.thumbnail instanceof File) {
      formData.append("thumbnail", data.thumbnail);
    }
    if (data.icon instanceof File) {
      formData.append("icon", data.icon);
    }
    try {
      const response = await ApiRequest("POST", `${featureUpdateEndPoint}/${feature_category_id}`, formData);
      toast.success(response.message);
      onHide();
    } catch (error) {
      console.error(error);
      toast.error("Update failed");
    }
  };

  return (
    <>
      <Modal className="add-modal-area" show={show} onHide={onHide} size="md" aria-labelledby="contained-modal-title-vcenter" centered >
        <Modal.Body>
          <button className="modal-close-button" onClick={onHide}><Icons name="cross" /></button>
          <form onSubmit={handleSubmit}>
            <div className="add-page-sections">Edit Feature</div>
            <div className="row">
              <div className="col-md-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Name<small>*</small></label>
                  </div>
                  <input name="title" value={data.title} type="text" placeholder="Enter Title" className="form-control" onChange={handleChange} required />
                </div>
              </div>

              <div className="col-md-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Slug<small>*</small></label>
                  </div>
                  <input name="category_slug" value={data.category_slug} placeholder="Slug" type="text" className="form-control" onChange={handleChange} required />
                </div>
              </div>


              <div className="col-md-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Brief<small>*</small></label>
                  </div>
                  <input name="brief" value={data.brief} type="text" placeholder="Brief" className="form-control" onChange={handleChange} />
                </div>
              </div>
            </div>

            <div className="add-page-inputs input-add-image">
              <div className="label-wrap-add">
                <label> Thumbnail Image (468 × 340)<small>*</small></label>
              </div>
              <CustomImageUpload
                name="thumbnail" acceptedFormats={[".webp"]} onImageChange={handleChange} imagePreview={previews.thumbnail} />
            </div>


            <div className="add-page-inputs input-add-image">
              <div className="label-wrap-add">
                <label>Icon (80 × 80)<small>*</small></label>
              </div>
              <CustomImageUpload  name="icon" acceptedFormats={[".webp"]} onImageChange={handleChange} imagePreview={previews.icon} />
            </div>
            <button type="submit" className="default-btn">Save Changes<span></span></button>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
}



